export default __webpack_public_path__ + "static/DSC_0040-f245e95981dc2dc8b0cefaefe49b2af4.jpg";